class FaqCategoryNav extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('.lp-faq-category__button');
      this.handleClick = this.handleClick.bind(this);
    }
  
    connectedCallback() {
      this.links.forEach(link => {
        link.addEventListener('click', this.handleClick);
      });
    }
  
    disconnectedCallback() {
      this.links.forEach(link => {
        link.removeEventListener('click', this.handleClick);
      });
    }
  
    handleClick(e) {
      const targetId = e.currentTarget.getAttribute('href');
  
      if (!targetId || !targetId.startsWith('#')) return;
  
      const targetEl = document.querySelector(targetId);
      if (!targetEl) return;
  
      e.preventDefault();
  
      const headerOffset = this.getHeaderOffset();
      const offsetTop =
        targetEl.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset;
  
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  
    getHeaderOffset() {
      // dynamic header detection (optional)
      const header = document.querySelector('header');
      return header ? header.offsetHeight : 100;
    }
  }
  
  customElements.define('faq-category-nav', FaqCategoryNav);